import Firebase from 'firebase'

const state = {
  user: null
}

const getters = {
  user: state => state.user
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  }
}

const actions = {
  signUserUp ({ commit }, payload) {
    commit('setLoading', true)
    commit('clearError')
    Firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(
      user => {
        commit('setLoading', false)
        const newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        }
        commit('setUser', newUser)
      }
    ).catch(
      error => {
        commit('setLoading', false)
        commit('setError', error)
        alert(error)
      }
    )
  },
  signUserIn ({ commit }, payload) {
    // commit('userStatus', user)
    Firebase.auth().signInWithEmailAndPassword(payload.email, payload.password).then(
      user => {
        commit('setLoading', false)
        const newUser = {
          id: payload.uid,
          name: payload.displayName,
          email: payload.email,
          photoUrl: payload.photoURL
        }
        commit('setUser', newUser)
      }
    ).catch(
      error => {
        commit('setLoading', false)
        commit('setError', error)
        // console.log(error)
        alert(error)
      }
    )
  },
  autoSignIn ({commit}, payload) {
    commit('setUser', {
      id: payload.uid,
      name: payload.displayName,
      email: payload.email,
      photoUrl: payload.photoURL
    })
  },
  resetPasswordWithEmail ({ commit }, payload) {
    const { email } = payload
    commit('setLoading', true)
    Firebase.auth().sendPasswordResetEmail(email).then(
      () => {
        commit('setLoading', false)
        console.log('Email Sent')
      }
    ).catch(
      error => {
        commit('setLoading', false)
        commit('setError', error)
        console.log(error)
      }
    )
  },
  logout ({commit}) {
    Firebase.auth().signOut()
    commit('setUser', null)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js